import { VulnerabilitiesAppNirvanaDataProvider } from '../dataProvider/VulnerabilitiesAppNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class VulnerabilitiesAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, VulnerabilitiesAppNirvanaDataProvider);
  }
}
